import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Validacao } from './validacao';
import { ValidacaoService } from './validacao.service';
import { Estudo } from '../estudo/estudo';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { MatSnackBar } from '@angular/material';



@Component({
    templateUrl: './validacao.concluir.component.html',
    selector: 'validacao-concluir'
})
export class ValidacaoConcluirComponent {
    @Input() estudo : Estudo;
    // Emite o estudo apos a conclusao
    @Output() estudoEmitido: EventEmitter<Estudo> = new EventEmitter<Estudo>();

    public lista : Validacao[];
    public isLoading: boolean;
    public mensagem: string = "";

    public mostrarBotaoConcluir: boolean = true;
    // construtor
    constructor(
      private validacaoService : ValidacaoService, private estudoService : EstudoService,
      public mensagemTela: MatSnackBar ) {   }

    // ngOnInit é executado ao entrar na tela
    public ngOnInit() {
      // atualizo o estudo soh de precaucao
      this.carregaEstudo();

    }

    private carregaEstudo(){
        this.isLoading= true;
        if(this.estudo && this.estudo.id){
          this.estudoService.getId(this.estudo.id).subscribe(
            result => {
              this.estudo = result;
              if(!(this.estudo.situacao == SituacaoEnum.Homologado || this.estudo.situacao == SituacaoEnum.Pontuado)){
                  this.mensagem = "<b>Ao clicar em 'Concluir Avaliação' o status do estudo será alterado conforme a regra:</b> <br>  ";
                  this.mensagem += "-Caso existam avaliações marcadas como 'não corrigidas': o status do estudo será alterado para: 'Para Correção' <br> ";
                  this.mensagem += "-Caso não existam avaliações ou existam avaliações e todas foram marcadas como 'corrigidas': o status do estudo será alterado para: 'Homologado' <br><br> ";
                  this.mensagem += "<b> Atenção: Uma vez que o status seja alterado para 'Homologado' não será possível alterar respostas do questionário. </b> <br>";
              }else{
                this.mensagem = "O estudo já foi Homologado ou Pontuado.";
                this.mostrarBotaoConcluir = false;
              }

              this.isLoading= false;
          },
            error => this.erro(error)
          );
      }
    }

   public concluirAvaliacao () {
   let validacao: Validacao = new Validacao();
   validacao.codigoEstudoSocioEconomico = this.estudo.id;
   this.isLoading = true;
   this.validacaoService.alterarStatusAvaliacao(validacao).subscribe((novoEstudo:Estudo) => {
      this.mensagemTela.open("Situação do estudo alterado de ''" + this.estudo.situacaoDenominacao + "'' para ''" + novoEstudo.situacaoDenominacao + "'", 'X', {duration: 5000});
      this.estudo= novoEstudo;
      this.estudoEmitido.emit(this.estudo);
      this.mostrarBotaoConcluir = false;
      this.isLoading = false;
   },
     error =>  this.erro(error)
   );
 }

    // mostra erros na tela
  private erro(erro: string){
     this.mensagemTela.open(erro, 'X', {duration: 5000});
     this.isLoading = false;
   }

   // finaliza o subscribe
  private finaliza(){
     this.isLoading =false;
   }

}
